import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  align-items: flex-end;
  justify-content: flex-end;
`;
const FlightName = styled.div``;
const FlightType = styled.div``;

export default function FlightNameAndType({ flightName, flightType }) {
  return (
    <Container>
      <FlightName>{flightName}</FlightName>
      <FlightType>{flightType}</FlightType>
    </Container>
  )
}
